




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Input from '@/components/common/elements/Input.vue';
import Select from '@/components/common/elements/Select.vue';
import Label from '@/components/common/elements/Label.vue';
import { SelectProps } from '@/constants/form/types';

@Component({
  components: { Input, Select, Label }
})
export default class SelectArea extends Vue {
  // name属性
  @Prop({ default: '' })
  private name!: string;
  // ラベル内テキスト
  @Prop({ default: '' })
  private label!: string;
  // 初期選択value
  @Prop({ default: '' })
  private value?: string;

  @Prop({ default: false })
  private isDisabled?: boolean;

  @Prop({ default: { name: '', options: [] } })
  private selectData!: SelectProps;

  @Emit('inputOperation')
  public inputOperation(value: { [k: string]: string }) {
    value.type = 'select';
    return value;
  }
}
